import { render, staticRenderFns } from "./EditUserNoteComment.vue?vue&type=template&id=e67900d2"
import script from "./EditUserNoteComment.vue?vue&type=script&lang=js"
export * from "./EditUserNoteComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports